import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import eadLogo from '../assets/logos/ead_logo_icon.png';
import '../styles/components/Navbar.css';

const Navbar = () => {
  const { lang, content } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(() => window.scrollY > 50);
  const [activeSection, setActiveSection] = useState('');
  const toggleRef = useRef(null);

  const navItems = [
    { label: content.roadmap.sectionTitle, href: '#roadmap' },
    { label: content.overview.sectionTitle, href: '#overview' },
    { label: content.model.sectionTitle, href: '#model' },
    { label: content.dataset.sectionTitle, href: '#dataset' },
    { label: content.notice.sectionTitle, href: '#notice' },
    { label: content.contributors.sectionTitle, href: '#contributor' },
    { label: content.alliance.sectionTitle, href: '#alliance' },
    { label: content.contact.sectionTitle, href: '#contact' },
  ];

  const closeMenu = () => {
    setIsOpen(false);
    toggleRef.current?.focus();
  };

  useEffect(() => {
    const sections = navItems.map(item => item.href.slice(1));
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      let current = '';
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) {
          current = id;
        }
      }
      setActiveSection(current);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  useEffect(() => {
    if (!isOpen) return;
    const handleOutsideClick = (e) => {
      if (!e.target.closest('.navbar')) {
        closeMenu();
      }
    };
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClick = () => {
    if (isOpen) closeMenu();
  };

  const menuLabel = lang === 'ko'
    ? (isOpen ? '내비게이션 메뉴 닫기' : '내비게이션 메뉴 열기')
    : (isOpen ? 'Close navigation menu' : 'Open navigation menu');

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`} aria-label={lang === 'ko' ? '주요 내비게이션' : 'Main navigation'}>
      <div className="navbar-container">
        <a className="navbar-logo" href="#hero" aria-label={content.hero.title}>
          <img src={eadLogo} alt="" className="navbar-logo-img" />
        </a>

        {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
        <ul id="navbar-menu" className={`navbar-links ${isOpen ? 'open' : ''}`} role="list">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={handleClick}
                className={activeSection === item.href.slice(1) ? 'active' : ''}
                aria-current={activeSection === item.href.slice(1) ? 'page' : undefined}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="navbar-right">
          <button
            type="button"
            ref={toggleRef}
            className={`navbar-toggle ${isOpen ? 'active' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label={menuLabel}
            aria-expanded={isOpen}
            aria-controls="navbar-menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
